import { render } from "./TramitesTiempoProceso.vue?vue&type=template&id=0dff0c4e&scoped=true"
import script from "./TramitesTiempoProceso.vue?vue&type=script&lang=js"
export * from "./TramitesTiempoProceso.vue?vue&type=script&lang=js"

import "./TramitesTiempoProceso.vue?vue&type=style&index=0&id=0dff0c4e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dff0c4e"]])

export default __exports__